// extracted by mini-css-extract-plugin
export default {"Markdown":"styles_Markdown__owQCv","MarkdownTextarea":"styles_MarkdownTextarea__kNC2-","MarkdownHighlighted":"styles_MarkdownHighlighted__CjrwL"};